import {collection, doc, FieldPath, getDoc, getDocs, query, where} from "firebase/firestore"
import {db} from "../../utility/firebaseConfig"

// get infos from firestore and save into local storage
export async function loginWithFirestore(userName, password) {


    // static case for ks03 where username and password is fixed
    // set demo content
    if (userName === "raf.silva" && password.trim().toLowerCase() === "konrad3009") {
        window.localStorage.setItem('episode', "003")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }
    // static case for ks03 EN-UK (Rafaela Silva). Password compared case-insensitively
    // (trim + toLowerCase) — canonical display casing is "Conrad3009" (print 2.1).
    // Username deliberately differs structurally from DE "raf.silva" so that no login is
    // one mistyped character away from another (non-mistypable-credentials principle).
    // The ENGLISH mail set for this account lives in @fake-db/apps/mail/en-GB/ks03.js
    // (story ids 70-74, spam ids 160-162), addressed to rafaela-silva@pronto-posto.com.
    if (userName === "rafaela-silva" && password.trim().toLowerCase() === "conrad3009") {
        window.localStorage.setItem('episode', "003")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }
    // KS03 IT: exact current print mailbox; follows existing case-insensitive password semantics.
    if (userName === "rafaela.s" && password.trim().toLowerCase() === "corrado3009") {
        window.localStorage.setItem('episode', "003")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }
    // static case for ks04 where username and password is fixed
    // set demo content
    if (userName === "m.lange" && password.trim().toLowerCase() === "maxderlange79") {
        window.localStorage.setItem('episode', "004")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }
    // static case for ks04 EN-UK (Maxwell Lang). Password compared case-insensitively
    // (trim + toLowerCase) — canonical display casing is "MaxWellEndowed79" (print flyer 1.6).
    if (userName === "maxwell.lang" && password.trim().toLowerCase() === "maxwellendowed79") {
        window.localStorage.setItem('episode', "004")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }
    // static case for ks04 FR (Maxime Legrand). Case-insensitive; display casing MaxLeGrand79.
    if (userName === "m.legrand" && password.trim().toLowerCase() === "maxlegrand79") {
        window.localStorage.setItem('episode', "004")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }
    // static case for ks04 IT (Massimo Lunghi). Case-insensitive; display casing MaxLungo79.
    if (userName === "m.lunghi" && password.trim().toLowerCase() === "maxlungo79") {
        window.localStorage.setItem('episode', "004")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }
    // static case for ks04 ES (Amadeo Grande). Case-insensitive; display casing ElGrande79.
    if (userName === "a.grande" && password.trim().toLowerCase() === "elgrande79") {
        window.localStorage.setItem('episode', "004")
        window.localStorage.setItem('phone_number', "123456789")
        window.localStorage.setItem('selected_difficulty', "medium")
        window.localStorage.setItem('user_id', "abcxyz")
        return true
    }

    if (!["francesca.amore", "marc.novak"].includes(userName)) return false

    // dynamic passwords for ks02 (individual pairs of rossi and novak for each player)
    // handle special case of rossi password that has leading string which is not saved in firestore
    if (userName === "francesca.amore") {
        password = password.replace(/\W/g, '') // remove special characters
        password = password.toLowerCase()
        const startStr = ["marcnovak3", "novakmarc3", "novak3", "marc3"]
        let found_leading_string = false
        startStr.forEach(str => {
            if (password.startsWith(str)) {
                password = password.substring(str.length)
                found_leading_string = true
            }
        })
        if (!found_leading_string) { return false }
    }
    // get User Data
    const q = query(collection(db, "auth"), where(new FieldPath(userName), "==", password))
    const querySnapshot = await getDocs(q)
    // check if password is correct
    const isCorrectPassword = (querySnapshot.size >= 1)
    if (!isCorrectPassword) {
        return false
    } else {
        // set passwords in app state
        // unsafe but necessary for insertion into email text for getting login info for other account
        const francesca_pw = querySnapshot.docs[0].data()["francesca.amore"]
        const novak_pw = querySnapshot.docs[0].data()["marc.novak"]
        window.localStorage.setItem('francesca.amore', francesca_pw)
        window.localStorage.setItem('marc.novak', novak_pw)
    }
    // get user information out of firestore
    const userID = querySnapshot.docs[0].id
    const docRef = doc(db, "users", userID)
    const docSnap = await getDoc(docRef)
    // set app states to reflect information
    if (docSnap.exists()) {
        // console.log("Document data:", docSnap.data())
        window.localStorage.setItem('episode', docSnap.data()["episode"])
        window.localStorage.setItem('phone_number', docSnap.data()["phone_number"])
        window.localStorage.setItem('selected_difficulty', docSnap.data()["selected_difficulty"])
        window.localStorage.setItem('user_id', docSnap.id)
    } else {
        // doc.data() will be undefined in this case
        return false
    }
    return true
}

// use jwt functionality to create tokens

export function loginWithJWT(userNameUser, passwordUser) {

    let fullNameUser = ""
    let avatarUser = require('@src/assets/images/portrait/small/avatar-s-11.jpg').default
    let displayUserRole = "Gratis Tarif"
    const emailUser = userNameUser.concat("@pronto-posto.com")
    if (userNameUser === "marc.novak") {
        fullNameUser = "Marc Novak"
        displayUserRole = "Gratis Tarif"
        avatarUser = require('@src/assets/images/portrait/novak.jpg').default
    } else if (userNameUser === "francesca.amore") {
        fullNameUser = "Francesca Rossi"
        avatarUser = require('@src/assets/images/portrait/rossi.jpg').default
        displayUserRole = "Premium Nutzer"
    } else if (userNameUser === "raf.silva") {
        fullNameUser = "Rafaela Silva"
        avatarUser = require('@src/assets/images/portrait/rafaela.png').default
        displayUserRole = "Gratis Tarif"
    } else if (userNameUser === "rafaela-silva") {
        // KS03 EN-UK — own mailbox (@fake-db/apps/mail/en-GB/ks03.js, ids 70-74 + 160-162).
        fullNameUser = "Rafaela Silva"
        avatarUser = require('@src/assets/images/portrait/rafaela.png').default
        displayUserRole = "Free Plan"
    } else if (userNameUser === "rafaela.s") {
        fullNameUser = "Rafaela Silva"
        avatarUser = require('@src/assets/images/portrait/rafaela.png').default
        displayUserRole = "Piano gratuito"
    } else if (userNameUser === "m.lange") {
        fullNameUser = "Maximilian Lange"
        avatarUser = require('@src/assets/images/portrait/lange.jpg').default
        displayUserRole = "Gratis Tarif"
    } else if (userNameUser === "maxwell.lang") {
        fullNameUser = "Maxwell Lang"
        avatarUser = require('@src/assets/images/portrait/lange.jpg').default
        displayUserRole = "Free Plan"
    } else if (userNameUser === "m.legrand") {
        fullNameUser = "Maxime Legrand"
        avatarUser = require('@src/assets/images/portrait/lange.jpg').default
        displayUserRole = "Forfait gratuit"
    } else if (userNameUser === "m.lunghi") {
        fullNameUser = "Massimo Lunghi"
        avatarUser = require('@src/assets/images/portrait/lange.jpg').default
        displayUserRole = "Piano gratuito"
    } else if (userNameUser === "a.grande") {
        fullNameUser = "Amadeo Grande"
        avatarUser = require('@src/assets/images/portrait/lange.jpg').default
        displayUserRole = "Plan gratuito"
    } else {
        return false
    }
    // determines what will be shown under in the user profile nav bar
    window.localStorage.setItem("displayUserRole", displayUserRole)

    const user = {
        id: 1,
        fullName: fullNameUser,
        username: userNameUser,
        password: passwordUser,
        avatar: avatarUser,
        email: emailUser,
        role: 'admin',
        ability: [
            {
                action: 'read', // changed from manage
                subject: 'all'
            }
        ],
        extras: {
            eCommerceCartItemsCount: 0
        }
    }

    return user

}
